module.exports = __webpack_public_path__ + "media/images/svg/logos_footer_m-fb66bfc6dadbf664c9c4683d5bf73c8b.svg";